module.exports = __webpack_public_path__ + "img/new_shoujihaibao_Pro.74530548.png";